import { useMutation } from '@tanstack/react-query'
import { Link } from 'react-router'
import { api } from '../../api/client'
import type { AppDetail } from '../../api/types'
import { useAuth } from '../../auth/AuthProvider'
import { PLATFORM_LABELS } from '../../hooks/useMeta'
import { AppIcon } from '../AppCell'

export function AppHeader({ app }: { app: AppDetail }) {
	const { user } = useAuth()
	const watch = useMutation({ mutationFn: () => api.post('/api/admin/watchlist', { appId: app.id }) })
	return (
		<header className="card row" style={{ gap: '1rem', alignItems: 'flex-start' }}>
			<AppIcon url={app.iconUrl} size="large" />
			<div style={{ flex: '1 1 260px', minWidth: 0 }}>
				<h1>{app.name}</h1>
				<p className="muted" style={{ margin: 0 }}>
					{app.developerName ?? 'Unknown developer'}
				</p>
				<p className="muted small" style={{ margin: '0.35rem 0 0' }}>
					{app.platforms.map((p) => PLATFORM_LABELS[p] ?? p).join(' · ') || 'Platforms unknown'}
					{app.currentVersion && ` · v${app.currentVersion}`}
					{app.bundleId && ` · ${app.bundleId}`} · id {app.id}
				</p>
			</div>
			<div className="row">
				<a className="button" href={app.storeUrl} target="_blank" rel="noreferrer">
					App Store ↗
				</a>
				<Link className="button" to={`/compare?apps=${app.id}`}>
					Compare with…
				</Link>
				{user?.role === 'admin' && (
					<button type="button" onClick={() => watch.mutate()} disabled={watch.isPending || watch.isSuccess}>
						{watch.isSuccess ? 'On review watchlist' : 'Watch reviews'}
					</button>
				)}
			</div>
		</header>
	)
}
